var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import i18next from 'i18next';
import { BookModel } from '../';
import { LAST_COURSE, TIMESPAN_TITLE_PRICE } from '../../../classConstants';
import { getPriceId } from '../../../components/BookingForm/booking-form.helpers';
import { getClassName } from '../../../helpers';
import { dateFormat, normalizeDate } from '../../../helpers/date';
import { CourseTimespanModelCollection } from "./CourseTimespanModelCollection";
import has from "lodash/has";
import get from "lodash/get";
import set from "lodash/set";
import { getSlotHandler } from "../../../SlotValidator/AvailabilityCollection";
import addMinutes from "date-fns/addMinutes";
import setMilliseconds from "date-fns/setMilliseconds";
import last from 'lodash/last';
import setDateFNS from 'date-fns/set';
import endOfDay from 'date-fns/endOfDay';
import startOfDay from 'date-fns/startOfDay';
import { ECourseColumns, EntitiesEnum } from '../../../store/store';
import parseISO from 'date-fns/parseISO';
var CourseTimespanModel = /** @class */ (function (_super) {
    __extends(CourseTimespanModel, _super);
    function CourseTimespanModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CourseTimespanModel.burstCache = function () {
        CourseTimespanModel.cachedSlots = {};
        CourseTimespanModel.cachedPriceStep = {};
    };
    CourseTimespanModel.getCollectionClass = function () {
        return CourseTimespanModelCollection;
    };
    Object.defineProperty(CourseTimespanModel.prototype, "title", {
        get: function () {
            return this.get("shortcut");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "maxQuantity", {
        get: function () {
            return this.get("max_quantity");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "shouldCollectParticipantInformation", {
        get: function () {
            return this.get("course_timespan_participation_type_name") !== "dont_collect_participants";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "shouldTakeOnlyOneParticipant", {
        get: function () {
            return this.get("course_timespan_participation_type_name") === "collect_one_participant";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "max_bookable_places_left", {
        get: function () {
            var places_left = this.placesLeft;
            return this.options.disableAvailabilityCheck ? Math.max(places_left, this.maxQuantity) : places_left;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "maxBookablePlacesLeftForReal", {
        get: function () {
            var places_left = this.placesLeftForReal;
            return this.options.disableAvailabilityCheck ? Math.max(places_left, this.maxQuantity) : places_left;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "placesLeftForReal", {
        get: function () {
            return this.get("places_left");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "placesLeft", {
        get: function () {
            var _a;
            var waitingListCount = this.options.noWaitingList ? 0 : ((_a = this.waitingListCount) !== null && _a !== void 0 ? _a : 0);
            return this.placesLeftForReal > 0 ? Math.max(this.placesLeftForReal, waitingListCount) : this.placesLeftForReal + waitingListCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "quantityLeftForReal", {
        get: function () {
            return this.get("quantity_left");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "quantityLeft", {
        get: function () {
            var _a;
            var waitingListCount = this.options.noWaitingList ? 0 : ((_a = this.waitingListCount) !== null && _a !== void 0 ? _a : 0);
            return Math.max(0, Math.min(this.maxQuantity, this.quantityLeftForReal > 0 ? Math.max(this.quantityLeftForReal, waitingListCount) : (this.quantityLeftForReal + waitingListCount)));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "max_quantity_left_for_real", {
        get: function () {
            return (this.options.disableAvailabilityCheck ? this.max_bookable_places_left : this.quantityLeftForReal);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "max_quantity_left", {
        get: function () {
            return (this.options.disableAvailabilityCheck ? this.max_bookable_places_left : this.quantityLeft);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "useExistingParticipant", {
        get: function () {
            return this.get("has_bill_personal_data") === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "hideSeparateBillReceipient", {
        get: function () {
            return this.get("hide_has_bill_personal_data") === 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "hasSeparateBillRecipient", {
        get: function () {
            return this.hideSeparateBillReceipient && this.useExistingParticipant;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "shouldHideBillRecipient", {
        get: function () {
            return this.shouldCollectParticipantInformation && this.hasSeparateBillRecipient;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "isSchedulingTimespan", {
        get: function () {
            return this.get("is_scheduling");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "reservedSchedulingSlots", {
        get: function () {
            var data = get(this, "scheduling_reserved_times", []).map(function (_a) {
                var from = _a.from, to = _a.to, props = __rest(_a, ["from", "to"]);
                return (__assign(__assign({}, props), { from: normalizeDate(from), to: normalizeDate(to) }));
            });
            return data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "hasStepPricing", {
        get: function () {
            var _a, _b;
            return ((_b = (_a = this.get("related.courseTimespansQuantitySteps")) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "minimumQuantity", {
        get: function () {
            var _a;
            return (_a = this.get("min_quantity_courses")) !== null && _a !== void 0 ? _a : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "bookedOut", {
        get: function () {
            return this.quantityLeftForReal <= 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "isNonBindingWaitingList", {
        get: function () {
            return !this.isSchedulingTimespan && this.get('waitlist_type_name') === 'non_binding_waitlist';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "waitingListCount", {
        get: function () {
            if (this.isNonBindingWaitingList && this.options.nonBindingWaitlistIsBookedOut)
                return 0;
            return this.isSchedulingTimespan ? 0 : this.get('waitlist_left');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "bookableWithWaitingList", {
        get: function () {
            return !this.isSchedulingTimespan && this.bookedOut && this.waitingListCount > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CourseTimespanModel.prototype, "hasLastBookingSlot", {
        get: function () {
            return this.waitingListCount === 1 && this.bookedOut;
        },
        enumerable: false,
        configurable: true
    });
    CourseTimespanModel.prototype.getMaxParticipantCount = function (_a) {
        var selectedSlot = _a.selectedSlot, allowAllEvents = _a.allowAllEvents;
        if (this.shouldTakeOnlyOneParticipant) {
            return 1;
        }
        if (!this.shouldCollectParticipantInformation) {
            return 1;
        }
        return allowAllEvents ? this.max_bookable_places_left : this.deriveQuantityLeft({ selectedSlot: selectedSlot });
    };
    CourseTimespanModel.prototype.tags = function () {
        return this.hasMany('tags');
    };
    CourseTimespanModel.prototype.courses = function () {
        return this.hasMany('courses');
    };
    CourseTimespanModel.prototype.place = function () {
        return this.hasOne('places', 'place');
    };
    CourseTimespanModel.prototype.customerPrices = function () {
        return this.hasMany('prices', 'customerPrices');
    };
    CourseTimespanModel.prototype.consentFormItem = function () {
        return this.hasOne('form_items', 'consentFormItem');
    };
    CourseTimespanModel.prototype.billReceiverFormItem = function () {
        return this.hasOne('form_items', 'billReceiverFormItem');
    };
    CourseTimespanModel.prototype.participantFormItem = function () {
        return this.hasOne('form_items', 'participantFormItem');
    };
    CourseTimespanModel.prototype.topFormItem = function () {
        return this.hasOne('form_items', 'topFormItem');
    };
    CourseTimespanModel.prototype.schedulingTimeRanges = function () {
        return this.hasMany('scheduling_time_ranges', 'schedulingTimeRanges');
    };
    CourseTimespanModel.prototype.courseTimespansQuantitySteps = function () {
        return this.hasMany('course_timespan_quantity_steps', 'courseTimespansQuantitySteps');
    };
    CourseTimespanModel.prototype.teachers = function () {
        try {
            return this.hasMany(EntitiesEnum.USERS, 'teachers').all();
        }
        catch (_a) {
            return [];
        }
    };
    CourseTimespanModel.prototype.appointments = function () {
        try {
            return this.hasMany(EntitiesEnum.COURSE_APPOINTMENTS, 'computedAppointments').all();
        }
        catch (_a) {
            return [];
        }
    };
    CourseTimespanModel.prototype.getFromAsFilterName = function () {
        var date = this.get('from');
        return date ? dateFormat(date, 'yyyy_M') : null;
    };
    CourseTimespanModel.prototype.getFormattedDate = function (prop, dateFormatString) {
        if (dateFormatString === void 0) { dateFormatString = i18next.t("date.date_format"); }
        var date = this.get(prop);
        if (!date)
            return null;
        return dateFormat(date, dateFormatString);
    };
    CourseTimespanModel.prototype.prepareAsRow = function (config) {
        var dataColumns = config.dataColumns, dryRun = config.dryRun, placement = config.placement, titleKey = config.titleKey, disableInfo = config.disableInfo, _a = config.fixedCourses, courses = _a === void 0 ? [] : _a, _b = config.fixedColumns, fixedColumns = _b === void 0 ? [] : _b, _c = config.maxPlacesThreshold, maxPlacesThreshold = _c === void 0 ? -1 : _c;
        var timespan = this;
        var record = { id: this.id };
        var courseList = timespan.courses().all();
        record['courseNames'] = courseList.map(function (c) { return c.get('name'); });
        record['tagNames'] = timespan
            .tags()
            .all()
            .map(function (c) { return c.get('name'); });
        record['fromRaw'] = parseISO(timespan.getRaw('from.date') || '0001-01-01').getTime();
        var placesLeft = this.deriveQuantityLeft({ key: 'max_quantity_left_for_real' });
        record['hasFewPlacesLeft'] = !!maxPlacesThreshold && !!placesLeft && placesLeft <= maxPlacesThreshold;
        return dataColumns.reduce(function (record, column) {
            var _a, _b, _c, _d, _e;
            var value = '';
            switch (column) {
                case ECourseColumns.TIMESPAN: {
                    value = dryRun
                        ? ''
                        : timespan.getAsTitle(courses, { placement: placement, titleKey: titleKey });
                    break;
                }
                case ECourseColumns.COURSE: {
                    value = courseList
                        .filter(function (course, index, self) {
                        return disableInfo ||
                            courseList.length === 1 ||
                            // || (self.length === 1 && !filterValues.courses?.includes(course.get("name")))
                            !courses.includes(course.id) ||
                            (index === self.length - 1 && (fixedColumns === null || fixedColumns === void 0 ? void 0 : fixedColumns.includes(ECourseColumns.COURSE)));
                    })
                        .map(function (course, index) {
                        var fixedIndex = courses.indexOf(course.id);
                        return i18next.t(placement + ".course_format", {
                            title: course.title,
                            position: fixedIndex > -1 ? fixedIndex + 1 : index + 1 + courses.length,
                            defaultValue: course.title,
                            id: course.name
                        });
                    })
                        .join(' ');
                    break;
                }
                case ECourseColumns.PLACE:
                    value = timespan.place().title;
                    break;
                case ECourseColumns.TRAINER:
                    value = timespan.teachers().map(function (teacher) { return teacher.getTrainer(); });
                    break;
                case ECourseColumns.APPOINTMENTS: {
                    var from_1 = timespan.getFormattedDate('from', i18next.t("date.time_format"));
                    if (!from_1)
                        break;
                    var to = timespan.getFormattedDate('to', i18next.t("date.time_format"));
                    if (!to)
                        break;
                    var appointments = timespan.appointments();
                    var hasStartTimeBeforeEnd = from_1 !== to && appointments.every(function (appointment) { var _a; return from_1 < ((_a = appointment.endTime) !== null && _a !== void 0 ? _a : ""); });
                    if (hasStartTimeBeforeEnd) {
                        value = [
                            i18next.t(placement + ".from_to_time", {
                                fromTime: from_1,
                                toTime: to,
                            })
                        ];
                    }
                    else {
                        value = appointments.map(function (appointment) { return appointment.getFromToAuto((placement)); });
                    }
                    break;
                }
                case ECourseColumns.APPOINTMENT_LIST: {
                    var from = timespan.getFormattedDate('from', i18next.t("date.time_format"));
                    if (!from)
                        break;
                    value = timespan.appointments().map(function (appointment) { return appointment.getFromToAuto((placement)); });
                    break;
                }
                case ECourseColumns.FROM: {
                    var fromDate = timespan.getFormattedDate('from');
                    record['fromRaw'] = parseISO(timespan.getRaw('from.date') || '0001-01-01').getTime();
                    if (!fromDate)
                        break;
                    var fromTime = timespan.getFormattedDate('from', i18next.t("date.time_format"));
                    var toDate = timespan.getFormattedDate('to');
                    var toTime = fromDate === toDate
                        ? timespan.getFormattedDate('to', i18next.t("date.time_format"))
                        : '';
                    var fromDateAuto = i18next.t(placement + ".from_date_auto", {
                        fromDate: fromDate,
                        fromTime: fromTime,
                        toTime: toTime && i18next.t("date.to_date_separator") + " " + toTime,
                    });
                    value = i18next.t(placement + ".from_date", {
                        fromDateAuto: fromDateAuto,
                        fromDate: fromDate,
                        fromTime: fromTime,
                        toTime: toTime,
                    });
                    break;
                }
                case ECourseColumns.TO: {
                    var fromDate = (_a = timespan.getFormattedDate('from')) === null || _a === void 0 ? void 0 : _a.trim();
                    var toDate = (_b = timespan.getFormattedDate('to')) === null || _b === void 0 ? void 0 : _b.trim();
                    record['toRaw'] = parseISO(timespan.getRaw('to.date') || '0001-01-01').getTime();
                    if (!toDate)
                        break;
                    var toTime = (_c = timespan.getFormattedDate('to', i18next.t("date.time_format"))) === null || _c === void 0 ? void 0 : _c.trim();
                    value =
                        fromDate === toDate
                            ? ''
                            : ((_d = i18next.t(placement + ".to_date", { toDate: toDate, toTime: toTime })) === null || _d === void 0 ? void 0 : _d.trim()) || '';
                    break;
                }
                case ECourseColumns.INFO:
                    value = (_e = timespan.get('presented.titleReplaced')) === null || _e === void 0 ? void 0 : _e.trim();
                    break;
                case ECourseColumns.DESCRIPTION:
                    if (courseList.length > 0 || disableInfo) {
                        value += courseList
                            .map(function (course) { var _a; return courses.includes(course.id) ? '' : ((_a = course.description) === null || _a === void 0 ? void 0 : _a.trim()) || ''; })
                            .join(' ')
                            .trim();
                    }
                    var timespanBody = timespan.get('presented.body').trim();
                    value += timespanBody && "<div class=\"ws-timespan-description\">" + timespanBody + "</div>";
                    break;
                case ECourseColumns.BOOKLINK:
                    record['waitinglist'] = timespan.bookableWithWaitingList;
                    value = timespan.get('max_quantity_left') <= 0 && !timespan.bookableWithWaitingList ? '' : timespan.get('presented.apiBookUrl');
                    break;
                case ECourseColumns.PRICE:
                    var size = dryRun ? timespan.customerPrices().size : 0;
                    if (dryRun && size) {
                        value += '' + size;
                    }
                    else
                        value = timespan.getCustomerPriceAsString();
                    break;
                case ECourseColumns.REMAINING:
                    value = timespan.getPlacesLeftAsString(placement + ".n_places_left", { key: 'max_quantity_left_for_real' });
                    break;
            }
            record[column] = value;
            record['sortKey'] = (record['fromRaw'] + ' ' + record[ECourseColumns.COURSE]).toLowerCase();
            return record;
        }, record);
    };
    CourseTimespanModel.prototype.getAvailablePrices = function (_a) {
        var quantity = _a.quantity, _b = _a.maxQuantity, maxQuantity = _b === void 0 ? null : _b;
        if (this.hasStepPricing) {
            if (!Number(quantity) || (maxQuantity !== null && maxQuantity < quantity)) {
                return this.customerPrices().filter(function () { return false; });
            }
            return this.customerPrices().availablePrices({ quantity: quantity });
        }
        return this.customerPrices();
    };
    CourseTimespanModel.prototype.deriveStepsRange = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, bookingSlot = _b.bookingSlot;
        var key = "_" + this.id;
        if (has(CourseTimespanModel.cachedPriceStep, key))
            return get(CourseTimespanModel.cachedPriceStep, key);
        var totalQuantityLeft = this.options.allowAllEvents ? this.max_bookable_places_left : this.deriveQuantityLeft({ selectedSlot: bookingSlot });
        var steps = this.courseTimespansQuantitySteps()
            .generateStepRange({ min_quantity: this.minimumQuantity, max_quantity: totalQuantityLeft })
            .map(function (quantity) {
            var _a;
            var priceId = (_a = _this.getAvailablePrices({ quantity: quantity, maxQuantity: totalQuantityLeft }).first()) === null || _a === void 0 ? void 0 : _a.id;
            return { priceId: priceId, quantity: quantity };
        });
        var translationKey = !steps.every(function (_a) {
            var _b;
            var priceId = _a.priceId;
            return priceId === ((_b = steps[0]) === null || _b === void 0 ? void 0 : _b.priceId);
        }) ? "bookcart.step_participant" : "bookcart.step_participant_with_one_price";
        steps = steps.map(function (_a) {
            var priceId = _a.priceId, quantity = _a.quantity;
            return ({
                value: String(quantity),
                label: "" + i18next.t(translationKey, {
                    quantity: quantity,
                    count: quantity,
                    amount: _this.getCustomerPriceAsString(priceId),
                    price_title: _this.getPriceTitle(priceId, true)
                })
            });
        });
        set(CourseTimespanModel.cachedPriceStep, key, steps);
        return CourseTimespanModel.cachedPriceStep[key];
    };
    CourseTimespanModel.prototype.getBookerCountOptions = function (_a) {
        var allowAllEvents = _a.allowAllEvents, price_id = _a.price_id, bookingSlot = _a.bookingSlot;
        if (this.hasStepPricing) {
            return this.deriveStepsRange({ bookingSlot: bookingSlot });
        }
        var totalQuantityLeft = allowAllEvents ? this.max_bookable_places_left : this.deriveQuantityLeft({ selectedSlot: bookingSlot });
        var maxBoolablePlaces = this.maxBookablePlacesLeftForReal;
        return new Array(Math.min(+totalQuantityLeft, CourseTimespanModel.MAX_BOOKABLE_PLACES)).fill(null).map(function (x, index) {
            var participantLabelKey = (index) >= maxBoolablePlaces ? "bookcart.participant_waiting_list" : "bookcart.participant";
            return ({
                value: index + 1,
                label: index + 1 + " " + i18next.t(participantLabelKey, { count: index + 1, }),
            });
        });
    };
    CourseTimespanModel.prototype.deriveQuantityLeft = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, selectedSlot = _b.selectedSlot, _c = _b.key, key = _c === void 0 ? 'max_quantity_left' : _c;
        if (!this.isSchedulingTimespan) {
            var maxQuantityLeft = this.get(key);
            return Math.max(0, maxQuantityLeft);
        }
        var minMax = function (count) { return Math.max(Math.min(_this.maxQuantity, count), 0); };
        if (!has(selectedSlot, "data.quantity_left")) {
            var maxQuantityPerSlot = this.schedulingTimeRanges().all().map(function (range) { return range.maxBookings; });
            return minMax(Math.max.apply(Math, maxQuantityPerSlot));
        }
        return minMax(get(selectedSlot, "data.quantity_left"));
    };
    CourseTimespanModel.prototype.getDateAsTitle = function (prop) {
        var date = this.get(prop);
        if (!date)
            return null;
        var thisYear = new Date().getFullYear();
        var dateFormatString = (new Date(date).getFullYear() === thisYear ? "MMMM" : 'MMMM yyyy');
        return dateFormat(date, dateFormatString);
    };
    CourseTimespanModel.prototype.getNormalizedFilterValues = function () {
        var _a;
        var months = this.getFromAsFilterName() || "-1";
        return {
            courses: this.courses().get('name'),
            places: [(_a = this.place()) === null || _a === void 0 ? void 0 : _a.get('name')],
            months: [months]
        };
    };
    CourseTimespanModel.prototype.getComputedPrice = function (form) {
        var _a;
        var priceId = getPriceId(form) || null;
        return priceId ? (_a = this.customerPrices().findById(priceId)) === null || _a === void 0 ? void 0 : _a.getComputedPrice(form) : null;
    };
    CourseTimespanModel.prototype.getCustomerPriceAsString = function (type) {
        if (type === void 0) { type = "lowest"; }
        switch (type) {
            case "lowest":
                return this.customerPrices().getLowestPrice();
            case "highest":
                return this.customerPrices().getHighestPrice();
            case "last":
                return this.customerPrices().getLastPrice();
            default:
                return this.customerPrices().getPrice(typeof type === "number" ? type : null);
        }
    };
    CourseTimespanModel.prototype.getPlacesLeftAsString = function (translateToken, deriveQuantityLeftArg) {
        if (!this.options.isAdminIntegration && !this.get("show_free_places"))
            return "";
        var fullyBooked = !translateToken ? i18next.t("bookcart.fully_booked", {
            max_quantity: this.get("max_bookable_places_left"),
            booking_count: this.get("booking_count"),
        }) : "";
        if (!translateToken)
            translateToken = "bookcart.n_places_left";
        return this.deriveQuantityLeft(deriveQuantityLeftArg) <= 0
            ? fullyBooked
            : i18next.t(translateToken, {
                count: this.get("max_bookable_places_left"),
                max_quantity: this.get("max_bookable_places_left"),
                booking_count: this.get("booking_count"),
            });
    };
    CourseTimespanModel.prototype.getDateString = function () {
        var from = this.getFormattedDate("from");
        var to = from && this.getFormattedDate("to");
        if (!from)
            return "";
        if (from === to)
            return from;
        return from + " - " + to;
    };
    CourseTimespanModel.prototype.getPriceTitle = function (priceId, showSinglPriceTitle) {
        var _a;
        if (showSinglPriceTitle === void 0) { showSinglPriceTitle = false; }
        var c = this.customerPrices();
        if (!showSinglPriceTitle && c.size === 1) {
            return "";
        }
        if (!showSinglPriceTitle && !priceId) {
            if (c.size === 1)
                return "";
        }
        return ((_a = c.findById(priceId)) === null || _a === void 0 ? void 0 : _a.title) || "";
    };
    CourseTimespanModel.prototype.getAsTitle = function (courseIds, _a, extraObject) {
        var _this = this;
        if (courseIds === void 0) { courseIds = []; }
        var _b = _a.placement, placement = _b === void 0 ? "bookcart" : _b, _c = _a.titleKey, titleKey = _c === void 0 ? "timespan_format" : _c, _d = _a.hidePlacesLeft, hidePlacesLeft = _d === void 0 ? false : _d, _e = _a.hidePrice, hidePrice = _e === void 0 ? false : _e, _f = _a.hideDateTime, hideDateTime = _f === void 0 ? false : _f;
        if (extraObject === void 0) { extraObject = null; }
        // const placesLeft = this.getPlacesLeftAsString()
        // const price = this.getCustomerPriceAsString();
        // const dateString = this.getDateString();
        if (this.options.isAdminIntegration)
            return i18next.t("bookcart.timespan_format", {
                course1: "",
                course2: "",
                course3: "",
                course4: "",
                course5: "",
                course6: "",
                course7: "",
                course8: "",
                course9: "",
                course10: "",
                fromDate: "",
                toDate: "",
                fromTime: "",
                toTime: "",
                fromToAuto: "",
                place: "",
                totalPrice: "",
                price: "",
                highestPrice: "",
                lowestPrice: "",
                lastPrice: "",
                waitlist: "",
                title: this.get("shortcut"),
                placesLeft: this.getPlacesLeftAsString(),
                bookingSlot: "",
                skipInterpolation: true
            });
        var priceId = get(extraObject, "priceId", null);
        var selectedSlot = get(extraObject, "selectedSlot", null);
        var showSinglPriceTitle = get(extraObject, "showSinglPriceTitle", false);
        var isWaitlistBooking = get(extraObject, "isBookingWaitlist", false);
        var title = this.get("presented.titleReplaced");
        var wrapInSpan = function (key, value) {
            var _a;
            var className = getClassName(key, (_a = {},
                _a[TIMESPAN_TITLE_PRICE] = key.toLowerCase().includes("price"),
                _a[LAST_COURSE] = "course" + courseData.length === key,
                _a));
            return (value === null || value === void 0 ? void 0 : value.trim()) ? "<span class=\"" + className + "\">" + value + "</span>" : "";
        };
        var courseData = this.courses()
            .filter(function (m) { return !courseIds.includes(m.id); })
            .all()
            .map(function (m) { var _a; return (_a = m.get("title")) === null || _a === void 0 ? void 0 : _a.trim(); }, [])
            .filter(Boolean);
        var courses = courseData
            .reduce(function (courseObject, string, i) {
            var key = "course" + (i + 1);
            courseObject[key] = wrapInSpan(key, string);
            return courseObject;
        }, {
            course1: "",
            course2: "",
            course3: "",
            course4: "",
            course5: "",
            course6: "",
            course7: "",
            course8: "",
            course9: "",
            course10: "",
        });
        var dateFormatString = i18next.t("date.date_format");
        var timeFormatString = i18next.t("date.time_format");
        var toDateSeparator = i18next.t("date.to_date_separator");
        var fromDate = this.getFormattedDate("from");
        var fromTime = this.getFormattedDate("from", timeFormatString);
        var toDate = this.getFormattedDate("to");
        var toTime = this.getFormattedDate("to", timeFormatString);
        var prependToDateSeparator = function (str) {
            if (!(str === null || str === void 0 ? void 0 : str.trim()))
                return "";
            return toDateSeparator + " " + str;
        };
        var fromToAuto = function (startDate, startTime, endDate, endTime) {
            var isSameDay = startDate === endDate;
            var isSameTime = startTime === endTime;
            return i18next.t(placement + ".from_to_auto", {
                fromDate: startDate,
                fromTime: startTime,
                toDate: isSameDay ? "" : prependToDateSeparator(endDate),
                toTime: !isSameDay ? endTime : (isSameTime ? "" : prependToDateSeparator(endTime))
            });
        };
        var titleProps = __assign({ fromDate: hideDateTime ? "" : function () { return wrapInSpan("fromDate", fromDate); }, toDate: hideDateTime ? "" : function () { return wrapInSpan("toDate", toDate); }, fromTime: hideDateTime ? "" : function () { return wrapInSpan("fromTime", fromTime); }, toTime: hideDateTime ? "" : function () { return wrapInSpan("toTime", toTime); }, fromToAuto: hideDateTime ? "" : function () { return wrapInSpan("fromToAuto", fromToAuto(fromDate, fromTime, toDate, toTime)); }, title: function () { return wrapInSpan("title", title); }, waitlist: !isWaitlistBooking ? "" : function () { return wrapInSpan('waitlist', i18next.t(placement + ".waitlist", { defaultValue: "" })); }, place: function () { var _a; return wrapInSpan("place", (_a = _this.place()) === null || _a === void 0 ? void 0 : _a.get("title")); }, placesLeft: hidePlacesLeft ? "" : function () { return wrapInSpan("placesLeft", _this.getPlacesLeftAsString()); }, 
            // totalPrice: hidePrice ? "" : () => wrapInSpan("totalPrice", this.getComputedPrice(form) || this.getCustomerPriceAsString(priceId)),
            priceTitle: hidePrice ? "" : function () { return wrapInSpan("priceTitle", !priceId ? "" : _this.getPriceTitle(priceId, showSinglPriceTitle)); }, totalPrice: hidePrice ? "" : function () { return wrapInSpan("totalPrice", _this.getCustomerPriceAsString(priceId && Number(priceId))); }, price: hidePrice ? "" : function () { return wrapInSpan("price", _this.getCustomerPriceAsString(priceId && Number(priceId))); }, highestPrice: hidePrice ? "" : function () { return wrapInSpan("highestPrice", _this.getCustomerPriceAsString("highest")); }, lowestPrice: hidePrice ? "" : function () { return wrapInSpan("lowestPrice", _this.getCustomerPriceAsString("lowest")); }, lastPrice: hidePrice ? "" : function () { return wrapInSpan("lastPrice", _this.getCustomerPriceAsString("last")); }, bookingSlot: !(selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.from) || !(selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.to) ? "" : function () { return wrapInSpan("bookingSlot", fromToAuto(dateFormat(normalizeDate(selectedSlot.from), dateFormatString), dateFormat(normalizeDate(selectedSlot.from), timeFormatString), dateFormat(normalizeDate(selectedSlot.to), dateFormatString), dateFormat(normalizeDate(selectedSlot.to), timeFormatString))); } }, courses);
        return i18next.t(placement + "." + titleKey, "", __assign(__assign({}, titleProps), { skipInterpolation: true })).replace(/\s+/g, " ");
    };
    CourseTimespanModel.prototype.getSchedulingDates = function (configuration) {
        if (configuration === void 0) { configuration = {}; }
        if (!this.isSchedulingTimespan)
            return [];
        var trCollection = this.schedulingTimeRanges(), maxDaysInFuture = this.get('schedule_max_days_in_future');
        var dates = trCollection
            .generateIncludedRangesForDays(maxDaysInFuture);
        if (!this.options.compute_timeslots_ahead_of_time) {
            return dates;
        }
        var availableSlots = Array.from(new Set(this.getSchedulingSlots(__assign(__assign({}, configuration), { computeAheadOfTime: true }))
            .filter(function (_a) {
            var isAvailable = _a.isAvailable;
            return isAvailable;
        })
            .map(function (_a) {
            var from = _a.from;
            return startOfDay(from).toDateString();
        })));
        return dates
            .filter(function (_a) {
            var from = _a.from;
            return availableSlots.includes(from.toDateString());
        });
    };
    CourseTimespanModel.prototype.getSchedulingSlots = function (configuration) {
        var _this = this;
        var _a;
        if (configuration === void 0) { configuration = {}; }
        var date = normalizeDate(get(configuration, "onDate", null));
        var shouldCalculateAheadOfTime = !!get(configuration, "computeAheadOfTime", false);
        var startOfDate = shouldCalculateAheadOfTime ? null : date && startOfDay(new Date(date));
        var bookersCount = get(configuration, "bookers_count", -1);
        var key = "_" + this.id + "._" + bookersCount + "._" + startOfDate;
        if (has(CourseTimespanModel.cachedSlots, key))
            return get(CourseTimespanModel.cachedSlots, key);
        var fail = false;
        if (!this.isSchedulingTimespan) {
            fail = true;
        }
        ;
        if (!shouldCalculateAheadOfTime && !startOfDate) {
            fail = true;
        }
        ;
        if (fail) {
            set(CourseTimespanModel.cachedSlots, key, []);
            return get(CourseTimespanModel.cachedSlots, key);
        }
        var trCollection = this.schedulingTimeRanges(), daysInFuture = this.get('schedule_max_days_in_future');
        var excluded = trCollection.generateExcludedRangesForDays(daysInFuture, startOfDate);
        var included = trCollection.generateIncludedRangesForDays(daysInFuture, startOfDate);
        var availableSlotDates = trCollection.generateAvailableSlotDates(daysInFuture, startOfDate);
        var now = setDateFNS(new Date(), { milliseconds: 0, seconds: 0 });
        var firstIncludedRangeFromNow = included.find(function (range) {
            return addMinutes(now, range.slotInterval) <= range.to;
        });
        var from = firstIncludedRangeFromNow
            ? setMilliseconds(addMinutes(new Date(), firstIncludedRangeFromNow === null || firstIncludedRangeFromNow === void 0 ? void 0 : firstIncludedRangeFromNow.minutesBefore), 0)
            : endOfDay(now);
        var availabilityManager = getSlotHandler({
            bookersCount: +bookersCount,
            availableSlots: included,
            excludedSlots: excluded,
            bookedEvents: this.reservedSchedulingSlots.filter(function (slot) { return from < slot.from; }),
            from: from,
            to: (_a = last(included)) === null || _a === void 0 ? void 0 : _a.to,
        });
        var slotStatuses = availableSlotDates.map(function (_a) {
            var slotStart = _a.slotStart, slotEnd = _a.slotEnd, maxBookings = _a.maxBookings, priority = _a.priority;
            var quantityLeft = _this.options.disableAvailabilityCheck ? _this.get("max_bookable_places_left") : maxBookings;
            return availabilityManager.getStatus(slotStart, slotEnd, quantityLeft, priority);
        });
        set(CourseTimespanModel.cachedSlots, key, slotStatuses);
        return get(CourseTimespanModel.cachedSlots, key);
    };
    CourseTimespanModel.MAX_BOOKABLE_PLACES = 50;
    CourseTimespanModel.cachedSlots = {};
    CourseTimespanModel.cachedPriceStep = {};
    CourseTimespanModel.dates = ['from', 'to'];
    return CourseTimespanModel;
}(BookModel));
export { CourseTimespanModel };
